import { useDispatch, useSelector } from 'react-redux';
import { ctxDorBlob, setCurrentTab, setDorBlob } from '../../../../store/reducers/patientContext';
import { useEffect } from 'react';
import { PATIENT_CONTEXT_TABS_ID } from '../../../../pages/ward/forms/formsUtil';
import makeStyles from '@mui/styles/makeStyles';
import { setSnackbar } from '../../../../store/reducers/globals';

const useStyles = makeStyles((theme) => ({
    iframe: {
        width: '100%',
        height: '99%',
    },
}));

const NoteDocumentRender = () => {
    const classes = useStyles();
    const dispatch = useDispatch();

    const dor = useSelector(ctxDorBlob);

    useEffect(() => {
        return () => {
            dispatch(setDorBlob(null));
        };
    }, []);

    if (!dor) {
        dispatch(setSnackbar({ type: 'error', message: 'Failed to load document' }));
        dispatch(setCurrentTab(PATIENT_CONTEXT_TABS_ID.NOTES));
        return null;
    }

    return <iframe className={classes.iframe} src={dor} title="Document of record" />;
};

export default NoteDocumentRender;
